import './Spinner.scss';

export class Spinner {
  
  private root: HTMLDivElement;
  private className: string = 'lds-dual-ring-improved';
  private backgroundColor: string = 'rgba(255, 255, 255, 0.5)';
  
  constructor(root: HTMLDivElement) {
    this.root = root;
    this.backgroundColor = window.getComputedStyle(this.root).backgroundColor;
  }
  
  public show() {
    this.root.classList.add(this.className);
  }
  
  public hide() {
    this.root.classList.remove(this.className);
  }
  
}